import * as vp from 'vopay';
import { Box, Table } from 'vopay';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PaymentMethodCard.module.scss';
import { useClientData } from '@/providers/ClientData.provider';
import { Button } from 'UI';

export type PaymentMethodCardProps = {
  Title: string;
  Description: string;
  AccountNumber: string;
  AccountHolder: string;
  ConnectionType?: string;
  Expiry?: string;
  CreditCardBrand?: string;
  BankId?: string;
  Type: 'credit' | 'bank';
  onClickFund?: () => void;
  onClickWithdraw?: () => void;
};

type FC = FunctionComponent<PaymentMethodCardProps>;
const PaymentMethodCard: FC = ({
  Title,
  Description,
  AccountNumber,
  AccountHolder,
  ConnectionType,
  Expiry,
  Type,
  BankId,
  CreditCardBrand,
  onClickFund,
  onClickWithdraw,
}: PaymentMethodCardProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.MyBankAccounts.BankAccountsContainer' });
  const {
    response: { SubAccountType },
  } = useClientData();
  const tableProps: vp.TableProps = {
    name: 'account-information',
    variant: 'detail',
    columns: {
      AccountNumber: { header: 'Account Number', align: 'left' },
      AccountHolder: { header: 'Account Holder', align: 'left' },
      ConnectionType: { header: 'Connection Type', align: 'left', visiblity: Type === 'bank' },
      ExpDate: { header: 'Exp. Date', align: 'left', visiblity: Type === 'credit' },
    },
    rows: [
      {
        AccountNumber:
          Type === 'bank' ? (
            <Box flx="row" ai="center">
              {BankId !== null && vp.hasBankImage(BankId || '') && (
                <img
                  className={styles.logos}
                  alt="bank logo"
                  src={`https://embed-dev.vopay.com/images/logos-banks/${BankId || ''}.svg`}
                />
              )}
              <span>{AccountNumber}</span>
            </Box>
          ) : (
            <Box flx="row" ai="center">
              {CreditCardBrand !== null && CreditCardBrand !== 'unknown' && (
                <img
                  alt="logo"
                  className={styles.logos}
                  src={`https://embed-dev.vopay.com/images/${CreditCardBrand || ''}.png`}
                />
              )}{' '}
              <span>{AccountNumber}</span>
            </Box>
          ),
        AccountHolder: <Box pe="sm">{AccountHolder || ''}</Box>,
        ConnectionType: vp.capitalizeFirstLetter(ConnectionType || ''),
        ExpDate: Expiry || '',
      },
    ],
  };
  return (
    <div className={styles.Card}>
      <Box flx="row" ai="center" jc="sb" height="auto">
        <h3 className={styles.Title}>{Title}</h3>
        {SubAccountType !== 'franchise' && (
          <Box flx="row">
            <Box pe="sm">
              {onClickFund && (
                <Button id="add-funds" size="small" onClick={onClickFund}>
                  {t('Card.addFunds', { defaultValue: 'Add Funds' })}
                </Button>
              )}
            </Box>
            <Box>
              {onClickWithdraw && (
                <Button id="withdraw-funds" size="small" onClick={onClickWithdraw}>
                  {t('Card.withdraw', { defaultValue: 'Withdraw' })}
                </Button>
              )}
            </Box>
          </Box>
        )}
      </Box>
      <p className={styles.Description}>{Description}</p>
      <Box flx="col" jc="sb">
        <Table {...tableProps} />
      </Box>
    </div>
  );
};
export default PaymentMethodCard;
